import {
  endOfDay,
  endOfMonth,
  formatISO,
  startOfDay,
  startOfMonth,
} from 'date-fns'

export interface ExportPeriod {
  useDateRange: boolean
  month: Date
  dateStart: Date
  dateEnd: Date
}

export function getExportPeriodBounds(period: ExportPeriod): [Date, Date] {
  if (period.useDateRange)
    return [startOfDay(period.dateStart), endOfDay(period.dateEnd)]

  return [startOfMonth(period.month), endOfMonth(period.month)]
}

export function getExportPeriodIso(period: ExportPeriod): [string, string] {
  const [start, end] = getExportPeriodBounds(period)
  return [formatISO(start), formatISO(end)]
}
